import { useLanguage } from '../context/LanguageContext';
import FlexiblePageWrapper from '../components/wrapper/FlexiblePageWrapper';
import Header from './../components/general/Header';
import Title from './../components/text/Title';
import Subtitle from '../components/text/Subtitle';
import Footer from './../components/general/Footer';
import RelationPraticalActivities from './../images/relation-practical-activities.png';

function Article() {
  const { t } = useLanguage();

  return (
    <FlexiblePageWrapper>
      <Header text={t('headerTitle')} />
      <main className="w-full max-w-4xl mx-auto sm:px-4 pt-40 pb-28 flex flex-col items-center gap-6">
        <Title size="big" text={t('title')} />
        <div className="w-full flex flex-col items-center justify-center border-b-2 border-gray">
          <br />
          <Subtitle size="surveySectionBig" text={t('articleGITSBSubtitle')} />
          <br />
        </div>
        <article className="text-subtitle-light dark:text-subtitle-dark flex flex-col gap-3">
          <p>{t('articleIntro01')}</p>
          <p>{t('articleIntro02')}</p>
          <p>{t('articleIntro03')}</p>
          <p>{t('articleIntro04')}</p>
        </article>
        <img
          src={RelationPraticalActivities}
          alt="Relationship between practical activities"
          className="h-60 block"
        />
        <span className="text-subtitle-light dark:text-subtitle-dark">
          Fig. 1: {t('articleIntro1Legend')}
        </span>
        <article className="text-subtitle-light dark:text-subtitle-dark w-full flex flex-col gap-2">
          <p>{t('articleIntro11')}</p>
          <ul className="my-2 list-disc pl-6 space-y-1">
            <li>{t('articleIntro12')}</li>
            <li>{t('articleIntro13')}</li>
            <li>{t('articleIntro14')}</li>
            <li>{t('articleIntro15')}</li>
            <li>{t('articleIntro16')}</li>
          </ul>
        </article>
        <article className="text-subtitle-light dark:text-subtitle-dark w-full flex flex-col gap-2">
          <div className="w-full">
            <Subtitle size="surveyQuestionBig" text={t('articleObjectiveTitle')} />
          </div>
          <p>{t('articleObjective01')}</p>
          <p>{t('articleObjective02')}</p>
          <ol className="my-2 pl-6 space-y-1 list-decimal">
            <li>{t('articleObjective021')}</li>
            <li>{t('articleObjective022')}</li>
          </ol>
          <p>
            <p>{t('articleObjective03')}</p>
          </p>
          <br />
          <div className="w-full">
            <Subtitle size="surveyQuestionBig" text={t('articleQueriesCaptureTitle')} />
          </div>
          <p>{t('articleQueriesCapture01')}</p>
          <p>{t('articleQueriesCapture02')}</p>
          <p>{t('articleQueriesCapture03')}</p>
          <p>{t('articleQueriesCapture04')}</p>
          <p>{t('articleQueriesCapture05')}</p>
          <br />
          <div className="w-full">
            <Subtitle size="surveyQuestionBig" text={t('articleLanguageQueriesTitle')} />
          </div>
          <p>{t('articleLanguageQueries01')}</p>
          <br />
          <div className="w-full">
            <Subtitle size="surveyQuestionBig" text={t('articleAnswersEvaluatedTitle')} />
          </div>
          <p>{t('articleAnswersEvaluated01')}</p>
          <p>{t('articleAnswersEvaluated02')}</p>
          <br />
          <div className="w-full">
            <Subtitle size="surveyQuestionBig" text="Survey Results" />
          </div>
          <p>{t('articleSurveyResults01')}</p>
          <p>{t('articleSurveyResults02')}</p>
          <p>{t('articleSurveyResults03')}</p>
        </article>
      </main>
      <Footer />
    </FlexiblePageWrapper>
  );
}

export default Article;
